<div class="plus" (click)="onClick()">
    <div class="addto" *ngIf="!isInWishlist">ADD TO MY LIST</div>
    <div class="addto" *ngIf="isInWishlist">REMOVE FROM MY LIST</div>
    <mat-icon  *ngIf="!isInWishlist" class="add">add_1</mat-icon>
    <mat-icon *ngIf="isInWishlist" class="remove">remove</mat-icon>
</div>